import { services } from '../../../../../constants/services';
import { getAll } from '../../../../../utils/api';

export const GetPermissionService = async (roleId: string) => {
  const response: any = await getAll<any[]>(`${services.roles}/${roleId}/permissions`);
  return response?.data;
};
